import { MapPin, Phone, Mail, Clock, Building2 } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 mt-6">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight uppercase mb-6" data-testid="about-page-title">Par mums / Kontakti</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <p className="text-base leading-relaxed">
            <strong>E-Commerce DEMO</strong> ir interneta veikala demonstrācija — saimniecības, higiēnas, tīrīšanas,
            rūpniecības un plastmasas preču <strong>vairumtirdzniecības un mazumtirdzniecības</strong> platformas paraugs.
          </p>
          <p className="text-base leading-relaxed mt-4">
            Mērķauditorija: uzkopšanas uzņēmumi, viesnīcas un restorāni (HoReCa), biroji, skolas, iestādes un
            ražotnes, kā arī privātie pircēji. Visi dati, kontakti un rekvizīti šajā vietnē ir izdomāti demonstrācijas nolūkiem.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            {[
              { icon: MapPin, t: "Adrese (demo)", d: "Demo iela 1, Demo pilsēta, LV-0000" },
              { icon: Phone, t: "Tālrunis (demo)", d: "+371 20 000 000" },
              { icon: Mail, t: "E-pasts (demo)", d: "info@ecommercedemo.lv" },
              { icon: Clock, t: "Darba laiks", d: "P.–Pk. 8:00–17:00, Se. 9:00–14:00" },
              { icon: Building2, t: "Rekvizīti (demo)", d: "E-Commerce DEMO · Reģ. nr. 40000000000 · PVN LV40000000000" },
            ].map((x) => (
              <div key={x.t} className="flex gap-3 items-start bg-[#F5F5F5] rounded-md p-4">
                <x.icon size={20} className="text-[#D0121A] shrink-0 mt-0.5" />
                <div>
                  <div className="text-sm font-bold">{x.t}</div>
                  <div className="text-sm text-[#6B6B6B]">{x.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-md overflow-hidden border border-[#E2E2E2] min-h-[400px]">
          <iframe title="Karte (demo atrašanās vieta)" data-testid="contact-map" className="w-full h-full min-h-[400px]" loading="lazy"
            src="https://www.openstreetmap.org/export/embed.html?bbox=23.9%2C56.9%2C24.3%2C57.05&layer=mapnik" />
        </div>
      </div>
    </div>
  );
}
